import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { offersInitialState, reducer } from './reducer';
import { setComparisonStatus, setContact, setError, setFavoriteStatus, setLayout, setLoading } from './actions';
import { fetchOffers } from '../../services/offers';
import { NewbuildingLayoutsContext } from '../../shared/context';
export function useOffers(_ref) {
  var newbuildingId = _ref.newbuildingId,
    houseId = _ref.houseId,
    layoutKey = _ref.layoutKey;
  var _React$useContext = React.useContext(NewbuildingLayoutsContext),
    httpApi = _React$useContext.httpApi,
    logger = _React$useContext.logger;
  var _React$useReducer = React.useReducer(reducer, offersInitialState),
    _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
    state = _React$useReducer2[0],
    dispatch = _React$useReducer2[1];
  var setOfferComparisonStatus = React.useCallback(function (offerId, status) {
    dispatch(setComparisonStatus(offerId, status));
  }, []);
  var setOfferFavoriteStatus = React.useCallback(function (offerId, isFavorite) {
    dispatch(setFavoriteStatus(offerId, isFavorite));
  }, []);
  var fetchLayout = React.useCallback(function (params) {
    dispatch(setLoading(true));
    dispatch(setError(false));
    fetchOffers({
      params: params,
      httpApi: httpApi,
      logger: logger
    }).then(function (layout) {
      dispatch(setLoading(false));
      if (!layout) {
        dispatch(setError(true));
        return;
      }
      var contact = layout.contacts.length === 1 ? layout.contacts[0] : null;
      dispatch(setLayout(layout));
      dispatch(setContact(contact));
    });
  }, []);
  var onRetry = React.useCallback(function () {
    if (!layoutKey) {
      return;
    }
    fetchLayout({
      newbuildingId: newbuildingId,
      houseId: houseId,
      layoutKey: layoutKey
    });
  }, [newbuildingId, houseId, layoutKey]);
  React.useEffect(function () {
    if (!layoutKey) {
      return;
    }
    fetchLayout({
      newbuildingId: newbuildingId,
      houseId: houseId,
      layoutKey: layoutKey
    });
  }, [layoutKey]);
  return {
    layout: state.layout,
    contact: state.contact,
    loading: state.loading,
    error: state.error,
    onRetry: onRetry,
    setComparisonStatus: setOfferComparisonStatus,
    setFavoriteStatus: setOfferFavoriteStatus
  };
}